'use client'

import { useModals } from '@/lib/hooks'
import { useAppSelector } from '@/lib/hooks/use-redux'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'
import type React from 'react'
import { use } from 'react'

import { AddToCart } from '@/components/forms/add-to-cart'
import { RefContext, type Refs } from '@/components/providers/ref-provider'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui'

interface AddToCartModalProps extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const AddToCartModal = ({ open }: AddToCartModalProps) => {
  const { closeModal } = useModals()
  const { product } = useAppSelector((state) => state.selectedProduct)
  const { barcodeInputRef } = use(RefContext) as Refs

  return (
    <Dialog
      open={open}
      onOpenChange={() => {
        barcodeInputRef.current?.focus()
      }}
    >
      <VisuallyHidden>
        <DialogTitle>Add To Cart</DialogTitle>
      </VisuallyHidden>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('ADD_TO_CART')}
        size="lg"
      >
        {product && <AddToCart product={product} />}
      </DialogContent>
    </Dialog>
  )
}
